import { HttpInterceptorFn, HttpParams } from '@angular/common/http';

export const NullQueryParamInterceptor: HttpInterceptorFn = (req, next) => {
  const filteredParams = cleanNullQueryParams(req.params);
  const clonedRequest = req.clone({ params: filteredParams });
  return next(clonedRequest);
};

function cleanNullQueryParams(params: HttpParams) {
  const paramsKeysAux = params.keys();
  paramsKeysAux.forEach((key) => {
    const value = params.get(key);
    if (value === 'null' || value === 'undefined' || value === '') {
      params['map'].delete(key);
    }
  });

  return params;
}
